import s from '../s';
import {ViewGlass} from '../i';
import AbTestStore, {ABTestKeys} from '../../global/store/ab-test-store';

// The glass selection, shared by both product page layouts. Moved unchanged from components/glass.tsx.

export const selectGlass = async (id: number): Promise<void> => {
    s.ui.update_pricing = true;
    s.ps.glass_id = id;
    s.pulse();
};

// ---- view model ------------------------------------------------------------------------------------------------------

/** product.tsx's mount rule for the glass section. */
export const glassSectionMounted = (): boolean => !s.IsPortal3 && !!s.prod && !!s.si && s.si.StoreTypeID !== 5 && s.si.IsGlassAllowed && !s.prod.disableGlassUpgrades;

/** Glass's own rule (also where the glass options test exposes): a frame on a store that allows glass, minus two products. */
export const glassSectionRendered = (): boolean => Boolean(s.ready && s.ui.show_cust && s.prod && s.si && s.si.IsGlassAllowed && s.prod.IsFrame && s.prod.ProductID !== 70214 && s.prod.ProductID !== 84054);

export const glassSectionShown = (): boolean => glassSectionMounted() && glassSectionRendered();

/** The glass tiles the control offers: Standard always; 2, 3, 4 as the product allows them (CAF: every one but 2); the legacy product_glass variant drops 2 and 3. */
export const isOfferedGlassTile = (m: ViewGlass): boolean =>
    ((s.prod.IsCAF && m.id !== 2) || m.id === 1 || (m.id === 2 && s.prod.AllowGlassID2 > 0) || (m.id === 3 && s.prod.AllowGlassID3 > 0) || (m.id === 4 && s.prod.AllowGlassID4 > 0)) &&
    (!AbTestStore.ABIsVariant(ABTestKeys.product_glass, 1) || (AbTestStore.ABIsVariant(ABTestKeys.product_glass, 1) && m.id !== 2 && m.id !== 3));

/** The frame is glazed with acrylic (the glass header, "Why does this frame have acrylic?"). */
export const isAcrylicGlazing = (): boolean => s.prod.AllowGlassID1 === 2 || s.ps.use_plexi;
